import React from 'react';
import Header from './Landing/Header/Header';
import {Outlet} from 'react-router-dom';
import Footer from './Landing/Footer/Footer';

export default function Home() {
  return (
    <React.Fragment>
      <div style={{backgroundColor: '#E9EFFB'}}>
        <Header/>
        <main style={{minHeight: '100vh'}}>
          <Outlet/>
        </main>
        <Footer/>
      </div>
    </React.Fragment>
  );
}
